




import { Component, Prop, Vue } from "vue-property-decorator";
import { OrganisationController } from "@proxy/OrganisationController";
import * as ModalStore from "@app/shared/modals/stores/modalStore";
import * as ApplicationStore from "@src/store/applicationStore";

@Component
export default class TermsAndConditionsLink extends Vue {
    @Prop() title: string;

    private openTermsAndContiditions(): void {
        let data: Modals.ModalState<any> = {
            name: ModalStore.WellknownModals.TermsAndConditionsModal,
            params: {
                src: this.termsAndContiditionsLink
            }
        };
        ModalStore.show(this.$store, data);
    }

    get termsAndContiditionsLink(): string {
        return new OrganisationController().termsAndConditionsLink();
    }
}
